import { doctorVerifyEmail } from './src/redux/middleware/user/doctor/verification';

const URL_PREFIX = '/app';
const PHARMACY_PREFIX = '/app/pharmacy';
const PATIENT_PREFIX = '/app/user';
export const APP_URLS = {
	home: `/`,
	// Patient endpoints
	patientRegister: `${PATIENT_PREFIX}/register`,
	patientLogin: `${PATIENT_PREFIX}/login`,
	patientForgotPassword: `${PATIENT_PREFIX}/forgot_password`,
	patientResetPassword: `${PATIENT_PREFIX}/reset_password`,
	patientProfileCompletion: `${PATIENT_PREFIX}/profile_completion`,
	patientDashboard: `${PATIENT_PREFIX}/dashboard`,
	patientSettings: `${PATIENT_PREFIX}/settings`,
	patientAssistant: `${PATIENT_PREFIX}/assistant`,
	patientProfile: `${PATIENT_PREFIX}/profile`,
	patientNotifications: `${PATIENT_PREFIX}/notifications`,
	patientWarning: `${PATIENT_PREFIX}_warning`,
	patientReminder: `${PATIENT_PREFIX}/reminder`,
	patientRefill: `${PATIENT_PREFIX}/refill`,
	patientUniversalMedicalRecord: `${PATIENT_PREFIX}/medicalrecord`,
	patientPurchases: `${PATIENT_PREFIX}/purchases`,
	patientTreatments: `${PATIENT_PREFIX}/treatments`,
	patientShare: `${PATIENT_PREFIX}/share`,
	// Cart and Product endpoints
	shoppingCart: `${URL_PREFIX}/shopping_cart`,
	checkout: `${URL_PREFIX}/checkout`,
	products: `${URL_PREFIX}/products`,
	inventory: `${URL_PREFIX}/inventory`,
	item: `${URL_PREFIX}/products/:id`,
	about: `${URL_PREFIX}/about`,
	contact: `${URL_PREFIX}/contact`,
	comingSoon: `${URL_PREFIX}/coming-soon`,
	drugsUpload: `${URL_PREFIX}/drugs_upload`,
	// MediChat endpoints (from file1)
	mediChatHome: `${URL_PREFIX}/home_feed`,
	mediChatGroups: `${URL_PREFIX}/medi_chat_groups`,
	mediChatPages: `${URL_PREFIX}/medi_chat_pages`,
	mediChatProfile: `${URL_PREFIX}/medi_chat_profile`,
	// pharmacy
	pharmacyRegister: `${PHARMACY_PREFIX}/register`,
	pharmacyVerifyEmail: `${PHARMACY_PREFIX}/verify-email`,
	pharmacyResetPassword: `${PHARMACY_PREFIX}/reset-password`,
	pharmacyLogin: `${PHARMACY_PREFIX}/login`,
	pharmacyForgotPassword: `${PHARMACY_PREFIX}/forgot_password`,
	pharmacyProfileCompletion: `${PHARMACY_PREFIX}/profile_completion`,
	pharmacyDashboard: `${PHARMACY_PREFIX}/dashboardpage`,
	// Hospital urls
	hospitalRegister: `${URL_PREFIX}/hospital/register`,
	hospitalLogin: `${URL_PREFIX}/hospital/login`,
	hospitalVerification: `${URL_PREFIX}/hospital/login/:token`,
	hospitalResetPassword: `${URL_PREFIX}/hospital/reset_password/:token`,
	hospitalForgotPassword: `${URL_PREFIX}/hospital/forgot_password`,
	hospitalVerifyEmail: `${URL_PREFIX}/hospital/verify_email/:token`,
	hospitalProfile: `${URL_PREFIX}/hospital/profile`,
	hospitalDashboard: `${URL_PREFIX}/hospital/dashboard`,
	// Doctor endpoints (from file2)
	doctorRegister: `${URL_PREFIX}/doctor/register`,
	doctorLogin: `${URL_PREFIX}/doctor/login`,
	doctorVerifyEmail: `${URL_PREFIX}/doctor/verify/email/:uidb64/:token`,
	doctorResetPassword: `${URL_PREFIX}/doctor/reset/password`,
	profileCompletion: `${URL_PREFIX}/doctor/profile/completion`,
	doctorPendingApproval: `${URL_PREFIX}/doctor/pending/approval`,
	doctorsDashboard: `${URL_PREFIX}/doctor/dashboard`,
};

const ENDPOINTS_URL = {};
